// @flow
/* eslint-disable import/prefer-default-export */
import minBy from 'lodash/minBy';

export function getSmallestFeature(map, e, extraLayers) {
  const features =
    e.features ||
    map.queryRenderedFeatures(e.point, {
      layers: [
        'selection-airspaces-trigger',
        'selection-airports-trigger',
        'airspace-small-label',
        'airport-with-afis',
        'airport-with-twr',
        'airports-wo-designation-label',
        'airfield-with-designation-no-freq-label',
        'airfield-with-designation-freq-label',
        'heliport-label',
        'airspace-mid-label',
        'airspace-large-label',
        ...extraLayers,
      ],
    });

  if (features.length) {
    return features.length === 1
      ? features[0]
      : minBy(
          features,
          f =>
            f.layer['source-layer'] === 'airports' ||
            f.layer.id.endsWith('-label') ||
            f.layer.id === 'airport-with-afis' ||
            f.layer.id === 'airport-with-twr' ||
            extraLayers.includes(f.layer.id)
              ? -Infinity
              : f.properties.area
        );
  }
}



// WEBPACK FOOTER //
// ./utils/map.js